import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import Image from "next/image";
import FImage from "next/image";
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import ApiClient from '../../utils/client'
import * as Sentry from '@sentry/nextjs'
import { useState, Fragment } from 'react'
import { CheckIcon, StarIcon } from '@heroicons/react/24/solid'
import { RadioGroup } from '@headlessui/react'
import { useForm } from 'react-hook-form'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { servicesById } from '../../queries/services'
import { currency } from '../../utils/formats'
import { useBasket } from '../../providers/basket'

import Phone from '../../assets/phone.svg'
import { Conversion, recordConversion } from '../../utils/conversions'
import { trackAction } from '../../utils/analytics'
import { useSession } from '../../providers/session'
import { Service, Product } from '../../interfaces'
import { faqTemplate, serviceTemplate } from '../../utils/schema'
import { classNames } from '../../utils/classnames'

const Layout = dynamic(() => import('../../components/layout'))
const Markdown = dynamic(() => import('../../components/molecules/markdown'))
const Modal = dynamic(() => import('../../components/organisms/modal'))
const Klarna = dynamic(() => import('../../components/klarna'), {
  ssr: false,
})

const offers = [
  {
    name: 'Laser Hair Removal',
    description: 'Get up to 80% off courses',
    href: '/laser-hair-removal/',
  },
  {
    name: 'Treatment Plans',
    description: 'Save On Individual Sessions With Plans',
    href: '/price-list/',
  },
  {
    name: 'Price Match Guarantee',
    description: 'Unbeatable Prices Guaranteed',
    href: '/price-list/',
  },
]

export default function Comp(props) {
  console.log(props)
  const { addItem } = useBasket()
  const { sourceParams } = useSession()
  const type = 'skin-boosters'
  const formatted = type && (type as string)
    .replace(/-/g, ' ')
    .replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase())

  const [state, setState] = useState({
    selectedOption: null,
    openInfoModal: false,
    infoModalContent: {
      body: '',
      highlight: '',
    },
    openFaqModal: false,
    faqModalContent: {
      faqs: [],
      highlight: '',
    },
    callback: false,
    loading: false,
    error: false,
    success: false,
  })

  function openModal(service: { content: any }, modalType: string) {
    if (modalType === 'info') {
      setState({
        ...state,
        infoModalContent: service.content,
        openInfoModal: true,
      })
    } else if (modalType === 'faq') {
      setState({
        ...state,
        faqModalContent: service.content,
        openFaqModal: true,
      })
    }
  }

  function bookNow(
    service: Service,
    x: Product,
    y: boolean,
    selectedOption: string
  ) {

    const findSelectedOption = service.pricing.filter(
      (x) => x.data.id === selectedOption
    )

    if (findSelectedOption.length > 0) {
      // Add selected service option
      addItem(service, x, y, selectedOption)
    } else {
      // Default to whichever service the book now button exists in
      addItem(service, x, y, service.pricing[0].data.id)
    }
  }

  const [selectedOption, setSelectedOption] = useState()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onTouched',
    reValidateMode: 'onChange',
  })

  const handle = async (data) => {
    if (state.loading) {
      return false
    }
    setState({
      ...state,
      loading: true,
      error: null,
    })

    try {
      const body = JSON.stringify({
        ...data,
        first_name: data.first_name.replace(/\s/g, ''),
        last_name: data.last_name.replace(/\s/g, ''),
        email: data.email.replace(/\s/g, '').toLowerCase(),
        phone: data.phone.replace(/\s/g, ''),
        subject: `${props.title} Callback Request`,
        message: `A new ${props.title} callback request has been made for ${data.first_name}.`,
        sourceParams,
        attributes: {
          // id: service.id,
          url: props.path,
          title: props.title,
        },
      })

      const r = await fetch('/api/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
      })

      const t = await r.json()

      trackAction('Callback')
      recordConversion({
        send_to: Conversion.callback,
        // @ts-ignore
        value: 1,
        currency: 'GBP',
      })
      ;(window as any).heap &&
        (window as any).heap.track('Callback Request', {
          method: 'Callback Request',
          service: props.title,
          ...data,
        })

      try {
        // @ts-ignore
        klaviyo &&
          // @ts-ignore
          klaviyo.push([
            'identify',
            {
              $email: data.email,
              $first_name: data.first_name,
              $last_name: data.last_name,
            },
          ])

        // @ts-ignore
        klaviyo &&
          // @ts-ignore
          klaviyo.push([
            'track',
            'Callback Request',
            {
              // ...item,
              $email: data.email,
              $first_name: data.first_name,
              $last_name: data.last_name,
              $phone_number: data.phone,
            },
          ])
      } catch (err) {
        console.log(err)
        Sentry.captureException(err)
      }

      setState({
        ...state,
        loading: false,
        error: null,
        success: true,
        callback: false,
      })
    } catch (err) {
      console.log(err)
      Sentry.captureException(err)
      setState({
        ...state,
        error: true,
        loading: false,
      })
    }
  }

  useEffect(() => {
    try {
      // @ts-ignore
      klaviyo &&
        // @ts-ignore
        klaviyo.push([
          'track',
          'View',
          {
            Category: (type as string)
              .replace(/-/g, ' ')
              .replace(/(^\w{1})|(\s{1}\w{1})/g, (match) =>
                match.toUpperCase()
              ),
            URL: window.location.href,
          },
        ])

      window.gtag &&
        window.gtag('event', 'view_item_list', {
          item_list_name: `${formatted} Treatments`,
          items: props.content.map((service) => ({
            id: service.id,
            item_id: service.id,
            name: service.title,
            item_name: service.title,
            price: service.pricing[service.pricing.length - 1].data.price / 100,
          })),
        })
    } catch (err) {
      console.log(err)
    }
  }, [])

  let meta = []
  let faqMeta = []

  props.services.forEach((x) => {
    meta.push(serviceTemplate(x))
    if (x.content.faqs) {
      faqMeta.push(faqTemplate(x.content.faqs))
    }
  })

  return <>
    <Layout>
      <Head>
        <title>{props.title} | Soluna London</title>
        <link
          rel="canonical"
          href={`https://solunalondon.com/skin-boosters/`}
        />
        <meta name="description" content={props.intro} />
        <link
          rel="alternate"
          hrefLang="en-GB"
          href={`https://solunalondon.com/skin-boosters/`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://solunalondon.com/skin-boosters/`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://solunalondon.com/skin-boosters/`}
        />
        {meta && meta.length > 0 && (
          <>
            {meta.map((x, i) => (
              <script
                key={`meta-${i}`}
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: `${JSON.stringify(x)}` }}
              />
            ))}
          </>
        )}
        {faqMeta && faqMeta.length > 0 && (
          <>
            {faqMeta.map((x, i) => (
              <script
                key={`faqMeta-${i}`}
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: `${JSON.stringify(x)}` }}
              />
            ))}
          </>
        )}
      </Head>
      <div className="bg-white">
        <div className="max-w-2xl mx-auto pt-16 pb-6 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-x-8 relative">
          {/* Product details */}
          <div className="lg:max-w-lg">
            <nav aria-label="Breadcrumb">
              <ol role="list" className="flex items-center space-x-2">
                <li>
                  <div className="flex items-center text-sm">
                    <Link
                      href="/treatments/"
                      passHref
                      className="font-medium text-gray-500 hover:text-gray-900">
                      
                        Treatments
                      
                    </Link>
                    <svg
                      viewBox="0 0 20 20"
                      xmlns="https://www.w3.org/2000/svg"
                      fill="currentColor"
                      aria-hidden="true"
                      className="ml-2 flex-shrink-0 h-5 w-5 text-gray-300"
                    >
                      <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                    </svg>
                  </div>
                </li>
                <li>
                  <div className="flex items-center text-sm">
                    <Link
                      href="/treatments/"
                      passHref
                      className="font-medium text-gray-500 hover:text-gray-900">

                      {props.category}

                    </Link>
                  </div>
                </li>
              </ol>
            </nav>

            <div className="mt-4">
              <h1 className="text-3xl font-serif font-medium text-gray-900 sm:text-4xl">
                {props.title}
              </h1>
            </div>

            <section aria-labelledby="information-heading" className="mt-4">
              <h2 id="information-heading" className="sr-only">
                {props.title} information
              </h2>

              <div className="flex items-center">
                <p className="text-lg text-gray-900 sm:text-xl">
                  <span className="text-xs">From:</span>{' '}
                  {currency(props.lowest)}
                </p>

                <div className="ml-4 pl-4 border-l border-gray-300">
                  <h2 className="sr-only">Reviews</h2>
                  <div className="flex items-center">
                    <div>
                      <div className="flex items-center">
                        {[0, 1, 2, 3, 4].map((rating) => (
                          <StarIcon
                            key={rating}
                            className={classNames(
                              props.stars >= rating
                                ? 'text-yellow-400'
                                : 'text-gray-300',
                              'h-5 w-5 flex-shrink-0'
                            )}
                            aria-hidden="true"
                          />
                        ))}
                      </div>
                      <p className="sr-only">{props.stars} out of 5 stars</p>
                    </div>
                    <p className="ml-2 text-sm text-gray-500">
                      {props.reviews} reviews
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 space-y-6 text-base text-gray-500">
                <Markdown source={props.intro}></Markdown>
              </div>

              {/* <div className="block mt-10 rounded-lg border border-gray-200 bg-gray-50 p-6 text-center group transition-colors duration-100 hover:border-brand-300">
                  <h2
                    id="sale-heading"
                    className="mt-1 text-gray-900 font-serif font-medium text-xl flex justify-center group-hover:text-brand-700"
                  >
                    Get 20% Off All Skin Boosters
                  </h2>
                  <p className="mt-4">
                    Offer is redeemed with code{' '}
                    <span className="underline">FEBBOOST</span>
                  </p>
                </div> */}
            </section>
          </div>

          {/* Product image */}
          <div
            className="mt-10 lg:mt-0 lg:col-start-2 lg:row-span-1 lg:self-start relative h-64 md:h-96 lg:h-full"
            style={{ maxHeight: 450 }}
          >
            <div className="rounded-md h-full">
              <Carousel
                dynamicHeight={false}
                showStatus={false}
                autoPlay
                infiniteLoop
              >
                {props.images.map((x, i) => {
                  return (
                    <div key={`image-${i}`}>
                      <Image
                        key={`image-${i}`}
                        className="rounded-lg"
                        alt={props.intro}
                        src={x}
                        fill
                        sizes="100vw" />
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>

          {/* Product form */}
          <div
            className={`lg:row-start-2 lg:col-span-2 lg:grid ${
              props.services.length % 3 === 0
                ? 'lg:grid-cols-3 lg:gap-8'
                : props.services.length > 4 && props.services.length % 3 !== 0
                ? 'lg:grid-cols-3 lg:gap-6'
                : props.services.length > 3
                ? 'lg:grid-cols-4 lg:gap-6'
                : props.services.length % 3 === 0
                ? 'lg:grid-cols-3 lg:gap-8'
                : 'lg:grid-cols-2 lg:gap-12'
            } border-t border-gray-300 mt-12`}
          >
            {props.services.map((service) => {
              const mainImage = service.media[0].asset.url
              const pricing = service.pricing.map(x => x.data.options.length > 0 ? x.data.options : x).flat()
              console.log('pricing', pricing)
              return (
                <div
                  key={service.id}
                  className="mt-12 lg:self-start w-full h-full"
                >
                  <section
                    className="h-full"
                    aria-labelledby="options-heading"
                  >
                    <h2 id="options-heading" className="sr-only">
                      {service.title} treatment options
                    </h2>

                    <div className="sm:flex h-full rounded-lg shadow-lg flex flex-col overflow-hidden">
                      <div className="rounded-lg overflow-hidden shadow w-full">
                        <FImage
                          // fill
                          width="320"
                          height="320"
                          sizes="(max-width: 768px) 400px,
                    (max-width: 1200px) 600px,
                    800px"
                          loading="eager"
                          decoding="async"
                          src={mainImage}
                          alt={
                            service.content.intro || service.content.callout
                          }
                          className="w-full h-full object-center object-cover"
                          priority
                          onLoadingComplete={(e) =>
                            setState((s) => ({
                              ...s,
                              mainImage: {
                                width: e.naturalWidth,
                                height: e.naturalHeight,
                              },
                            }))
                          }
                        />
                      </div>
                      {/* Size selector */}
                      <RadioGroup
                        value={selectedOption}
                        onChange={setSelectedOption}
                        className="w-full px-4 pb-4"
                      >
                        <RadioGroup.Label className="block text-2xl font-serif text-gray-900 md:mb-0 mb-2 font-medium mt-4">
                          {service.content.landingTitle || service.title}
                        </RadioGroup.Label>
                        {service.attributes && service.attributes.qualities && (
                          <>
                            <div className="my-5 md:my-2 flex flex-col space-y-3 flex-1 justify-center">
                              {service.attributes.qualities.map(
                                (quality, i) => (
                                  <div
                                    className="flex items-center"
                                    key={`quality-${i}`}
                                  >
                                    <CheckIcon
                                      style={{
                                        position: 'relative',
                                        top: '-3px',
                                      }}
                                      className="flex-shrink-0 w-5 h-5 text-brand-500"
                                      aria-hidden="true"
                                    />
                                    <p className="ml-2 text-sm text-gray-500">
                                      {quality}
                                    </p>
                                  </div>
                                )
                              )}
                            </div>
                          </>
                        )}
                        <div>
                          <div>
                            <>
                              <h3>
                                <button
                                  onClick={() => openModal(service, 'info')}
                                  className="group relative w-full py-2 flex justify-between items-center text-left"
                                >
                                  <span className="text-gray-900 font-medium text-lg">
                                    Information
                                  </span>
                                  <span className="ml-6 flex items-center">
                                    <InformationCircleIcon
                                      className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </button>
                              </h3>
                              <div className="sr-only overflow-hidden">
                                <Markdown
                                  source={service.content.body}
                                ></Markdown>
                              </div>
                            </>
                          </div>
                          {service.content.faqs &&
                            service.content.faqs.length > 0 && (
                              <div>
                                <>
                                  <h3>
                                    <button
                                      onClick={() =>
                                        openModal(service, 'faq')
                                      }
                                      className="group relative w-full py-2 flex justify-between items-center text-left"
                                    >
                                      <span className="text-gray-900 font-medium text-lg">
                                        FAQs
                                      </span>
                                      <span className="ml-6 flex items-center">
                                        <InformationCircleIcon
                                          className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                          aria-hidden="true"
                                        />
                                      </span>
                                      {service.content.faqs.map(
                                        ({ heading, body }, i) => {
                                          return (
                                            <div
                                              key={i}
                                              className="sr-only overflow-hidden"
                                            >
                                              <h4>{heading}</h4>
                                              <Markdown
                                                source={body}
                                              ></Markdown>
                                            </div>
                                          )
                                        }
                                      )}
                                    </button>
                                  </h3>
                                </>
                              </div>
                            )}
                        </div>
                        <div className="mt-1 grid gap-4 grid-cols-1">
                          {pricing
                            .filter((x) => x.data.label !== 'Booking Fee')
                            .map(({ data }) => (
                              <RadioGroup.Option
                                as="div"
                                key={data.id}
                                value={data.id}
                                className={({ active, checked }) =>
                                  classNames(
                                    active || checked
                                      ? 'ring-2 ring-brand-500'
                                      : '',
                                    'relative block border border-gray-300 rounded-lg p-4 cursor-pointer focus:outline-none'
                                  )
                                }
                              >
                                <RadioGroup.Label
                                  as="p"
                                  className="text-sm text-gray-500 font-medium"
                                >
                                  {data.label}
                                </RadioGroup.Label>
                                <RadioGroup.Description
                                  as="p"
                                  className="mt-1 font-medium text-base text-gray-900"
                                >
                                  {currency(data.price)}
                                </RadioGroup.Description>
                                <div aria-hidden="true" />
                              </RadioGroup.Option>
                            ))}
                        </div>
                        <div className="mt-4">
                          <button
                            onClick={() =>
                              bookNow(service, null, false, selectedOption || pricing[0].data.id)
                            }
                            className="btn-primary sm:mr-8 mt-2"
                            type="button"
                          >
                            Book Now
                          </button>
                        </div>
                        <div className="mt-4 text-center">
                          <Link
                            href={service.metadata.path}
                            passHref
                            className="text-sm text-gray-500 flex items-center justify-center">
                            More information<svg
                              xmlns="https://www.w3.org/2000/svg"
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 7l5 5m0 0l-5 5m5-5H6"
                              />
                            </svg>

                          </Link>
                        </div>
                      </RadioGroup>
                    </div>
                  </section>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <nav aria-label="Offers" className="order-last lg:order-first border-t">
        <div className="mx-auto max-w-7xl lg:px-8 border-l border-r">
          <ul
            role="list"
            className="grid grid-cols-1 divide-y divide-gray-200 lg:grid-cols-3 lg:divide-y-0 lg:divide-x"
          >
            {offers.map((offer) => (
              <li key={offer.name} className="flex flex-col">
                <a
                  href={offer.href}
                  className="relative flex flex-1 flex-col justify-center bg-white py-6 px-4 text-center focus:z-10"
                >
                  <p className="text-sm text-gray-500">{offer.name}</p>
                  <p className="font-semibold text-gray-900">
                    {offer.description}
                  </p>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      <section className="bg-brand-800">
        <div className="mx-auto max-w-7xl md:grid md:grid-cols-2 md:px-6 lg:px-8">
          <div className="py-12 px-4 sm:px-6 md:flex md:flex-col md:border-r md:border-brand-900 md:py-16 md:pl-0 md:pr-10 lg:pr-16">
            <q className="mt-6 md:flex md:flex-grow md:flex-col">
              <div className="relative text-lg font-medium text-white md:flex-grow">
                <svg
                  className="absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-brand-600"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <p className="relative">
                  Had 3 hydra facials at Soluna London so far and I
                  can&apos;t wait to go back. The facial itself is so relaxing
                  (I almost fall asleep every time) and my skin feels/ looks
                  amazing after but the staff are even better - they are
                  lovely and welcoming and make sure they know exactly what
                  you want out of your experience, can&apos;t recommend
                  Soluna London enough!
                </p>
              </div>
              <footer className="mt-8">
                <div className="flex items-center">
                  <div className="inline-flex flex-shrink-0 rounded-full border-2 border-white">
                    <img
                      className="h-12 w-12 rounded-full"
                      src="https://lh3.googleusercontent.com/a-/ACNPEu95cAGbz8neuozrOy4xVVcT-Fwde3SjltfluHm-Cw=s40-c-c0x00000000-cc-rp-mo-br100"
                      alt=""
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-base font-medium text-white">
                      Jordan O&apos;Driscoll
                    </div>
                  </div>
                </div>
              </footer>
            </q>
          </div>
          <div className="border-t-2 border-brand-900 py-12 px-4 sm:px-6 md:border-t-0 md:border-l md:py-16 md:pr-0 md:pl-10 lg:pl-16">
            <q className="mt-6 md:flex md:flex-grow md:flex-col">
              <div className="relative text-lg font-medium text-white md:flex-grow">
                <svg
                  className="absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform text-brand-600"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <p className="relative">
                  Have been receiving facial peels from Soluna London for
                  chickenpox scars that left my face in a bad way. The ladies
                  have been lovely! From the consultation to now the
                  treatments. No one tried to upsell me anything and
                  they&apos;ve been incredibly kind. Happy to be going there!
                </p>
              </div>
              <footer className="mt-8">
                <div className="flex items-center">
                  <div className="inline-flex flex-shrink-0 rounded-full border-2 border-white">
                    <img
                      className="h-12 w-12 rounded-full"
                      src="https://lh3.googleusercontent.com/a-/ACNPEu9tGp2dco6j3sMwXh2Hsr7oL4ymhCQXibRGFDQx0g=s40-c-c0x00000000-cc-rp-mo-br100"
                      alt=""
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-base font-medium text-white">
                      Majean G
                    </div>
                  </div>
                </div>
              </footer>
            </q>
          </div>
        </div>
      </section>
      {/* callback module */}
      <div className="bg-white">
        <div className="max-w-2xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:max-w-7xl">
          <div className="relative rounded-lg overflow-hidden h-96">
            <div className="absolute inset-0">
              <Image
                src={props.callback.imageUrl}
                alt={props.callback.body}
                className="w-full h-full object-center object-cover"
                fill
                sizes="100vw" />
            </div>
            <div
              aria-hidden="true"
              className="relative w-full h-96 lg:hidden"
            ></div>
            <div
              aria-hidden="true"
              className="relative w-full h-32 lg:hidden"
            ></div>
            <div className="absolute inset-x-0 bottom-0 bg-black bg-opacity-75 p-6 rounded-bl-lg rounded-br-lg backdrop-filter backdrop-blur sm:flex sm:items-center sm:justify-between lg:inset-y-0 lg:inset-x-auto lg:w-96 lg:rounded-tl-lg lg:rounded-br-none lg:flex-col lg:items-start">
              <div>
                <h2 className="text-xl font-bold text-white lg:text-2xl">
                  {props.callback.heading}
                </h2>
                <p className="mt-3 text-sm lg:text-base text-gray-300">
                  {props.callback.body}
                </p>
              </div>

              <button
                type="submit"
                className="btn-primary mt-6 sm:mt-0"
                onClick={() =>
                  setState({
                    ...state,
                    callback: true,
                  })
                }
              >
                <span className="absolute left-0 inset-y pl-3 text-white">
                  <Phone className="h-5 w-5 text-white group-hover:text-brand-400 transition ease-in-out duration-150 fill-current" />
                </span>
                {props.callback.ctaText}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* klarna module */}
      <div className="px-8 bg-black relative z-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* @ts-ignore */}
          <Klarna
            data-key="homepage-promotion-box"
            data-locale="en-GB"
            data-theme="dark"
          >
            {/* @ts-ignore */}
          </Klarna>
        </div>
      </div>
      {/* footer module */}
      <div className="relative bg-white overflow-hidden">
        <div className="pt-16 pb-96 sm:pt-24 sm:pb-40 lg:pt-20 lg:pb-48">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:static">
            <div className="sm:max-w-lg">
              <div>
                <Markdown
                  source={props.banner.body}
                  renderers={{
                    h3: (props) => (
                      <h3 className="font-serif text-4xl font font-medium tracking-tight text-gray-900 sm:text-6xl">
                        {props.children}
                      </h3>
                    ),
                    h4: (props) => (
                      <h4 className="font-serif text-4xl font font-medium tracking-tight text-gray-900 sm:text-6xl">
                        {props.children}
                      </h4>
                    ),
                  }}
                />
              </div>
              <Link
                href={props.banner.link}
                passHref
                className="inline-block text-center bg-brand-600 border border-transparent rounded-md py-3 px-8 font-medium text-white hover:bg-brand-700 font-serif mt-6 text-xl">

                {props.banner.ctaText}

              </Link>
            </div>
            <div>
              <div className="mt-10">
                <div
                  aria-hidden="true"
                  className="pointer-events-none lg:absolute lg:inset-y-0 lg:max-w-7xl lg:mx-auto lg:w-full"
                >
                  <div className="absolute transform sm:left-1/2 sm:top-12 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                    <div className="flex items-center space-x-6 lg:space-x-8">
                      <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden sm:opacity-0 lg:opacity-100  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[0]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[1]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                      </div>
                      <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[3]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[4]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                      </div>
                      <div className="flex-shrink-0 grid grid-cols-1 gap-y-6 lg:gap-y-8">
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[5]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                        <div className="relative w-44 h-64 rounded-lg overflow-hidden  md:shadow-lg">
                          <Image
                            className="w-full h-full object-center object-cover"
                            src={props.banner.imagesArray[2]}
                            alt=""
                            fill
                            sizes="100vw" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.related && props.related.length > 0 ? (
        <div className="bg-white">
          <div className="pt-4 pb-16 md:py-16 sm:py-24 xl:max-w-7xl xl:mx-auto xl:px-8">
            <div className="px-4 sm:px-6 sm:flex sm:items-center sm:justify-between lg:px-8 xl:px-0">
              <h2 className="text-2xl font-extrabold tracking-tight text-gray-900">
                {props.relatedTitle}
              </h2>
              <Link
                href={props.relatedLink}
                passHref
                className="hidden text-sm font-semibold text-brand-600 hover:text-brand-500 sm:block">

                {props.relatedLinkText}
                <span aria-hidden="true"> &rarr;</span>

              </Link>
            </div>

            <div className="mt-4 flow-root">
              <div className="-my-2">
                <div className="box-content py-2 relative h-80 overflow-x-auto xl:overflow-visible">
                  <div className="absolute min-w-screen-xl px-4 flex space-x-8 sm:px-6 lg:px-8 xl:relative xl:px-0 xl:space-x-0 xl:grid xl:grid-cols-5 xl:gap-x-8">
                    {props.related.map((category) => (
                      (<Link
                        href={category.href}
                        passHref
                        key={category.name}
                        className="relative w-56 h-80 rounded-lg p-6 flex flex-col overflow-hidden hover:opacity-75 xl:w-auto">

                        <span
                          aria-hidden="true"
                          className="absolute inset-0"
                        >
                          <Image
                            src={category.imageSrc}
                            alt={category.name}
                            className="w-full h-full object-center object-cover"
                            fill
                            sizes="100vw" />
                        </span>
                        <span
                          aria-hidden="true"
                          className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-gray-800 opacity-70"
                        />
                        <span className="relative mt-auto text-center text-xl font-medium font-serif text-white">
                          {category.name}
                        </span>

                      </Link>)
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 px-4 sm:hidden">
              <Link
                href={props.relatedLink}
                passHref
                className="block text-sm font-semibold text-brand-600 hover:text-brand-500">

                {props.relatedLinkText}
                <span aria-hidden="true"> &rarr;</span>

              </Link>
            </div>
          </div>
        </div>
      ) : null}
    </Layout>
    <Modal
      open={state.openInfoModal}
      close={() => setState({ ...state, openInfoModal: false })}
    >
      <div className="prose prose-brand prose-sm">
        <Markdown
          source={state.infoModalContent.body}
          renderers={{
            p: function P({ children }) {
              return <p className="text-base mb-2">{children}</p>
            },
            li: function LI({ children }) {
              return <li className="text-base mb-2">{children}</li>
            },
            heading: function H({ children }) {
              return <h3 className="font-serif text-xl mb-4">{children}</h3>
            },
            h1: function H({ children }) {
              return <h1 className="font-serif text-xl mb-4">{children}</h1>
            },
            h2: function H({ children }) {
              return <h2 className="font-serif text-xl mb-4">{children}</h2>
            },
            h3: function H({ children }) {
              return <h3 className="font-serif text-xl mb-4">{children}</h3>
            },
            h4: function H({ children }) {
              return <h4 className="font-serif text-xl mb-4">{children}</h4>
            },
            img: function Img(props) {
              return (
                <span className="block relative aspect-w-12 aspect-h-8">
                  <Image
                    className="rounded-md shadow-md object-fill"
                    src={props.src}
                    alt={state.infoModalContent.highlight}
                    fill
                    sizes="100vw" />
                </span>
              );
            },
          }}
        />
      </div>
    </Modal>
    <Modal
      open={state.openFaqModal}
      close={() => setState({ ...state, openFaqModal: false })}
    >
      <div className="prose prose-brand prose-sm">
        {state.faqModalContent.faqs.map(({ heading, body }, i) => (
          <Fragment key={`faq-${i}`}>
            <h4>{heading}</h4>
            <Markdown
              source={body}
              renderers={{
                p: function P({ children }) {
                  return <p className="text-base mb-2">{children}</p>
                },
                li: function LI({ children }) {
                  return <li className="text-base mb-2">{children}</li>
                },
                heading: function H({ children }) {
                  return (
                    <h3 className="font-serif text-xl mb-4">{children}</h3>
                  )
                },
                h1: function H({ children }) {
                  return (
                    <h1 className="font-serif text-xl mb-4">{children}</h1>
                  )
                },
                h2: function H({ children }) {
                  return (
                    <h2 className="font-serif text-xl mb-4">{children}</h2>
                  )
                },
                h3: function H({ children }) {
                  return (
                    <h3 className="font-serif text-xl mb-4">{children}</h3>
                  )
                },
                h4: function H({ children }) {
                  return (
                    <h4 className="font-serif text-xl mb-4">{children}</h4>
                  )
                },
                img: function Img(props) {
                  return (
                    <span className="block relative aspect-w-12 aspect-h-8">
                      <Image
                        className="rounded-md shadow-md object-fill"
                        src={props.src}
                        alt={state.faqModalContent.highlight}
                        fill
                        sizes="100vw" />
                    </span>
                  );
                },
              }}
            />
          </Fragment>
        ))}
      </div>
    </Modal>
    <Modal
      open={state.callback}
      close={() => setState({ ...state, callback: false })}
    >
      <div className="w-72 mx-auto">
        <form onSubmit={handleSubmit(handle)} className="space-y-3">
          <h3 className="font-serif text-xl text-center">
            Request a callback
          </h3>
          <label htmlFor="name" className="block">
            <input
              id="name"
              name="first_name"
              type="text"
              placeholder="Enter your name"
              className="appearance-none relative block w-full px-4 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:shadow-outline-brand focus:z-10 sm:text-sm sm:leading-5 focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:placeholder-gray-400"
              {...register('first_name', { required: true })}
            />
          </label>
          {errors.first_name && (
            <p className="text-red-500">Name is required</p>
          )}
          <label htmlFor="surname" className="block">
            <input
              id="surname"
              name="last_name"
              type="text"
              placeholder="Enter your surname"
              className="appearance-none relative block w-full px-4 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:shadow-outline-brand focus:z-10 sm:text-sm sm:leading-5 focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:placeholder-gray-400"
              {...register('last_name', { required: true })}
            />
          </label>
          {errors.last_name && (
            <p className="text-red-500">Surname is required</p>
          )}
          <label htmlFor="phone" className="block">
            <input
              id="phone"
              name="phone"
              type="tel"
              placeholder="Enter your phone number"
              className="appearance-none relative block w-full px-4 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:shadow-outline-brand focus:z-10 sm:text-sm sm:leading-5 focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:placeholder-gray-400"
              {...register('phone', { required: true })}
            />
          </label>
          {errors.phone && (
            <p className="text-red-500">Phone number is required</p>
          )}
          <label htmlFor="email" className="block">
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              className="appearance-none relative block w-full px-4 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:shadow-outline-brand focus:z-10 sm:text-sm sm:leading-5 focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:placeholder-gray-400"
              {...register('email', { required: true })}
            />
          </label>
          {errors.email && <p className="text-red-500">Email is required</p>}
          <button
            type="submit"
            className="btn-primary"
            disabled={state.loading}
          >
            Submit
          </button>
        </form>
      </div>
    </Modal>
    <Modal
      open={state.success}
      close={() => setState({ ...state, success: false })}
    >
      <div className="w-72 mx-auto">
        <h3 className="font-serif text-xl text-center">
          Your details have been submitted!
        </h3>
        <p>
          Thank you for your interest in Soluna London. We will be in touch
          with you by phone or email shortly.
        </p>
      </div>
    </Modal>
  </>;
}

const data = {
  services: [
    '54b98254-bc5a-4e06-96d8-f43e0741f747',
    '2bd27845-3550-4718-99e7-adf0c48e849d',
    'cef6059c-959a-45d2-856c-37b3ecbc4cd0',
    '69963eb1-f143-40ce-8ac0-647feef9bb95',
    'e6b4de66-fb3a-406f-a27b-d994b4c2c136',
    'e7f72354-1d3e-480f-bea3-b48f1911f6e5'
  ],
  stars: 4,
  reviews: 74,
  intro:
    'Experience emboldened confidence after receiving a skin boosting enhancement at Soluna London. Enhance your appearance with a service dedicated to you, administered safely by experts.\n\nWith skin boosters you can rejuvenate your appearence to reveal a fresher looking you, plump fine lines and hydrate your skin.\n\nSkin boosters are a versatile treatment option and are suitable for anyone looking to hydrate, plump and smooth their skin',
  category: 'Injectables',
  title: 'Skin Boosters',
  callback: {
    heading: 'Request a callback from one of our aesthetic experts',
    body: 'We offer in-depth, comprehensive consultations with an experienced aesthetician to answer all of your questions and give you expert advice when considering injectable enhancements',
    ctaText: 'Request A Callback',
    imageUrl: '/services/profhilo-banner.jpeg',
  },
  banner: {
    body: '### Skin concerns?\n\n#### We have skin experts!',
    ctaText: 'Book a consultation',
    link: 'https://solunalondon.com/advanced-facial-consultation/',
    imagesArray: [
      'https://solunalondon.com/services/facials/detox.jpg',
      'https://solunalondon.com/static/media/dermplaning.e99c25eb.png',
      'https://solunalondon.com/static/media/mesotherapy.00cdb3c1.png',
      'https://solunalondon.com/services/facials/hollywood-facial.jpg',
      'https://solunalondon.com/services/facials/calm-down.jpg',
      'https://solunalondon.com/services/skinceuticals/correct.jpg',
    ],
  },
  relatedTitle: 'Popular Injectables',
  relatedLink: '/dermal-fillers/',
  relatedLinkText: 'Browse all injectables',
  related: [
    {
      name: 'Anti Wrinkle',
      href: '/anti-wrinkle-injections/',
      imageSrc: '/services/fillers/anti-wrinkle-injections.jpg',
    },
    {
      name: 'Lip Enhancement',
      href: '/lip-enhancement/',
      imageSrc: '/images/lip-enhancements-london.png',
    },
    {
      name: 'Jawline',
      href: '/jawline-enhancement/',
      imageSrc: '/images/jawline-filler.png',
    },
    {
      name: 'Vampire',
      href: '/dracula-skin-therapy/',
      imageSrc:
        'https://solunalondon.com/_next/image/?url=%2Fservices%2Ffacials%2Fvampire_facial.jpg&w=3840&q=75',
    },
    {
      name: 'Rhinoplasty',
      href: '/non-surgical-rhinoplasty/',
      imageSrc: '/static/media/nose-side-by-side2.fcca8988.png',
    },
  ],
}

export async function getStaticProps({ params, preview = false }) {
  const { services, ...rest } = data
  const client = ApiClient()

  const servicesData = await client.query({
    query: servicesById,
    variables: {
      ids: services,
    },
  })

  // format
  const images = servicesData.data.services
    .map((x) => {
      return x.media.map((y) => y.asset.url)
    })
    .flat()

  const prices = servicesData.data.services
    .map((x) => {
      return x.pricing
        .map((y) => {
          if (y.data.options && y.data.options.length > 0) {
            return y.data.options.map((z) => z.data.price)
          } else {
            return [y.data.price]
          }
        })
        .flat()
    })
    .flat()
    .filter((x) => x > 2500)
    .sort((a, b) => a - b)

  return {
    revalidate: 60 * 60,
    props: {
      path: `/skin-boosters/`,
      images,
      lowest: prices[0],
      services: servicesData.data.services,
      ...rest,
    },
  }
}
